import { Text } from '@shared/components/Text';
import { TextField } from '@shared/data/entity/fields/TextField';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: TextField;
}

export function TextCollectionViewField({ field }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer fieldType={field.fieldType} multiline={field.multiline}>
      <Text data-slot="text" size="body1" numberOfLines={field.multiline ? 4 : 2}>
        {field.value}
      </Text>
    </CardCollectionViewFieldContainer>
  );
}
